import { Component, inject } from '@angular/core';
import { filter, map, startWith } from 'rxjs';
import { Header } from '../header/header';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { APP_ROUTES } from '../../core/constants/app-navigation.constants';
import { toSignal } from '@angular/core/rxjs-interop';
import { Footer } from '../footer/footer';

const NO_PADDING_ROUTES: readonly string[] = [
  `/${APP_ROUTES.ERROR}`,
  `/${APP_ROUTES.UNAUTHORIZED}`,
  '/',
];

@Component({
  standalone: true,
  imports: [RouterOutlet],
  selector: 'app-master',
  styleUrl: './master.scss',
  templateUrl: './master.html',
})
export class Master {
  private readonly router = inject(Router);
  private readonly isNoPaddingUrl = (url: string) => NO_PADDING_ROUTES.includes(url.split('?')[0]);

  protected readonly isNoPaddingRoute = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => this.isNoPaddingUrl(event.urlAfterRedirects)),
      startWith(this.isNoPaddingUrl(this.router.url)),
    ),
    { initialValue: this.isNoPaddingUrl(this.router.url) },
  );
}
